const UNIT_SUFFIX_REGEX = /U\d{2}$/i;

export const stripUnitSuffix = (value?: string | null): string => {
  if (!value) return "";
  return value.replace(UNIT_SUFFIX_REGEX, "");
};
